import { render } from "./ImportRequest.vue?vue&type=template&id=52a10074&ts=true"
import script from "./ImportRequest.vue?vue&type=script&lang=ts"
export * from "./ImportRequest.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__